"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentDivider = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * @internal
 */
exports.ContentDivider = function () {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: "gd-share-dialog-content-divider" })));
};
//# sourceMappingURL=ContentDivider.js.map